import { useBusinessNames } from '../../../../hooks/useBusinessNames';
import { useDomainSearchGateBi } from '../../../../hooks/useDomainSearchGateBi';
import { useRecommendations } from '../../../../hooks/useRecommendations';
import { useResultsPageOfferingsBi } from '../../../../hooks/useResultsPageOfferingsBi';
import { ViewMode } from '../../../../types';
const PAGE_LOAD_ERROR_MESSAGES = {
  NetworkIssue: 'domain_search_gate.bng_results.error.full_page.connection.description',
  ServerError: 'domain_search_gate.bng_results.error.full_page.description'
};
export const useBngResults = _ref => {
  let queryFromUrl = _ref.queryFromUrl,
    twoStep = _ref.twoStep;
  const isResultsVisible = (twoStep == null ? void 0 : twoStep.isDomainsStepVisible) ?? true;
  useDomainSearchGateBi({
    viewMode: ViewMode.STOREFRONT_BNG,
    deferResultsPageLoad: Boolean(twoStep),
    isResultsVisible,
    bngMobileSearchTerm: twoStep ? queryFromUrl : undefined
  });
  const _useBusinessNames = useBusinessNames({
      query: queryFromUrl,
      enabled: Boolean(queryFromUrl)
    }),
    hasBusinessNamesError = _useBusinessNames.hasError,
    isBusinessNamesReady = _useBusinessNames.isReady,
    businessNamesError = _useBusinessNames.error,
    retryBusinessNames = _useBusinessNames.retry;
  const _useRecommendations = useRecommendations({
      limit: 10,
      enableOnEmptyQuery: false,
      shouldFetchRecommendations: Boolean(queryFromUrl) && isBusinessNamesReady
    }),
    recommendations = _useRecommendations.recommendations,
    isLoading = _useRecommendations.isLoading,
    hasNextPage = _useRecommendations.hasNextPage,
    fetchNextPage = _useRecommendations.fetchNextPage,
    isFetchingNextPage = _useRecommendations.isFetchingNextPage,
    error = _useRecommendations.error,
    biError = _useRecommendations.biError,
    biErrorSubtype = _useRecommendations.biErrorSubtype,
    onRetry = _useRecommendations.onRetry,
    taxesNotIncluded = _useRecommendations.taxesNotIncluded,
    isPricingLoading = _useRecommendations.isPricingLoading;
  useResultsPageOfferingsBi({
    recommendations,
    isLoading,
    includeHeroCardOffers: true,
    biError,
    biErrorSubtype,
    enabled: isResultsVisible
  });
  const pageLoadErrorMessage = businessNamesError === 'NetworkIssue' || businessNamesError === 'ServerError' ? PAGE_LOAD_ERROR_MESSAGES[businessNamesError] : undefined;
  const domainSuggestionsProps = {
    recommendations: isBusinessNamesReady ? recommendations : [],
    isLoading: queryFromUrl ? !isBusinessNamesReady || isLoading : false,
    isPricingLoading,
    hasMore: isBusinessNamesReady && hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    hasFetchError: Boolean(error && error !== 'NoRecommendations'),
    onRetry,
    searchTerm: queryFromUrl
  };
  return {
    hasBusinessNamesError,
    isBusinessNamesReady,
    pageLoadErrorMessage,
    retryBusinessNames,
    hasRecommendations: recommendations.length > 0,
    taxesNotIncluded,
    domainSuggestionsProps
  };
};
//# sourceMappingURL=useBngResults.js.map